import { fixFormattedDateToISOString } from '../../../utils/dateFormatter';
import { getSchedule } from '../../../api/schedule.api';
import { SchedulingSectionStatus } from '../../../service-page-view-model/scheduling-section-view-model/schedulingSectionViewModel';
import { WidgetConfig } from '../../../types/shared-types';
import { ServiceType } from '@wix/bookings-uou-types';

export function getServiceSchedulingData(
  config: WidgetConfig,
  settings,
  httpClient,
  instance,
) {
  const serviceType = config.serviceDto.type;
  const isCourse = serviceType === ServiceType.COURSE;
  const isIndividual = serviceType === ServiceType.INDIVIDUAL;

  if (!isIndividual) {
    const now = new Date();
    const from = isCourse
      ? fixFormattedDateToISOString(
          config?.SEO?.serviceResponse?.schedules[0].firstSessionStart,
        )
      : now.toISOString();
    const to = isCourse
      ? fixFormattedDateToISOString(
          config?.SEO?.serviceResponse?.schedules[0].lastSessionEnd,
        )
      : new Date(
          now.setDate(now.getDate() + settings.scheduleDays),
        ).toISOString();
    if (from && to) {
      return httpClient.request(getSchedule, {
        headers: { authorization: instance },
      })([config?.SEO?.serviceResponse?.service?.scheduleIds[0]], from, to);
    }
  }
  return Promise.resolve({ status: SchedulingSectionStatus.EMPTY });
}
